import React from "react";
import { Modal, Table } from "antd";
import styled from "@emotion/styled";
import COLORS from "common/Colors";
import { dateInDetail } from "utils/Date";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getLocations } from "redux/selectors";

const StyledModal = styled(Modal)`
  width: 600px !important;

  .ant-modal-header {
    text-transform: uppercase;
    max-width: 95%;
  }
`;
const StyleLocation = styled.div`
  a {
    font-size: 12px;
  }
`;

const StyledTable = styled(Table)`
  .ant-table-content {
    overflow-x: auto;
    max-height: 500px;
    white-space: nowrap;
    border: 1px solid #00000024;
    border-radius: 10px;
  }
  .ant-table-cell {
    padding: 10px;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .non-white {
    background: #f9f9f9;
  }
  .normal-column {
    white-space: normal;
  }
  .ant-table-thead > tr > th::before {
    display: none !important;
  }

  .ant-table-cell-row-hover {
    background: #e3e8fc !important;
  }
`;

const geoCache = new Map();
const geoInFlight = new Map();

const fetchAddress = (lat, lng) => {
  const key = `${lat},${lng}`;

  if (geoCache.has(key)) return Promise.resolve(geoCache.get(key));
  if (geoInFlight.has(key)) return geoInFlight.get(key);

  const promise = fetch(
    `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`,
    { headers: { "Accept-Language": "en" } }
  )
    .then((r) => r.json())
    .then((d) => {
      const a = d?.address;
      const label =
        a?.office ||
        a?.building ||
        a?.amenity ||
        a?.road ||
        a?.suburb ||
        a?.city ||
        d?.display_name?.split(",").slice(0, 2).join(", ") ||
        key;
      geoCache.set(key, label);
      geoInFlight.delete(key);
      return label;
    })
    .catch(() => {
      geoCache.set(key, key);
      geoInFlight.delete(key);
      return key;
    });

  geoInFlight.set(key, promise);
  return promise;
};

const useGeoAddress = (lat, lng) => {
  const key = lat && lng ? `${lat},${lng}` : null;

  const [address, setAddress] = React.useState(() =>
    key ? geoCache.get(key) ?? null : null
  );
  const [loading, setLoading] = React.useState(() =>
    key ? !geoCache.has(key) : false
  );

  React.useEffect(() => {
    if (!key) return;

    if (geoCache.has(key)) {
      setAddress(geoCache.get(key));
      setLoading(false);
      return;
    }

    let cancelled = false;
    fetchAddress(lat, lng).then((label) => {
      if (!cancelled) {
        setAddress(label);
        setLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [key]);

  return { address, loading };
};

const LocationCell = React.memo(({ lat, lng, hasother, locationName }) => {
  const hasCoords =
    lat != null &&
    lat !== "" &&
    lat !== undefined &&
    lng != null &&
    lng !== "" &&
    lng !== undefined;

  const { address, loading } = useGeoAddress(
    hasCoords ? lat : null,
    hasCoords ? lng : null
  );

  if (!hasCoords) return <span>-</span>;
  if (loading)
    return <span style={{ color: "#888", fontSize: 12 }}>Resolving…</span>;

  const mapUrl = `http://maps.google.com/maps/?q=${lat},${lng}`;
  return (
    <>
      <a href={mapUrl} target="_blank" rel="noreferrer">
        {hasother ? address : locationName}
      </a>
      <br />
      <span style={{ fontSize: "10px", color: "#ccc" }}>
        {lat}, {lng}
      </span>
    </>
  );
});

function LocationBasedAttendanceList({
  displayModal,
  toggleModal,
  title,
  list,
  reportType,
}) {
  console.log("reportType-->", reportType);
  const { t } = useTranslation();
  const locationList = useSelector(getLocations) || [];

  const columns = [
    {
      title: t("Name"),
      dataIndex: "fullname",
      key: "fullname",
    },
    {
      title: t("Department"),
      dataIndex: "departmentName",
      key: "departmentName",
    },
    {
      title: t("Check-In Time"),
      dataIndex: "checkintime",
      key: "checkintime",
      align: "start",
      render: (checkintime) => {
        return checkintime.slice(0, 5);
      },
    },
  ];

  if (
    reportType === "Others" ||
    reportType === "Other" ||
    reportType === "Kenya Other" ||
    reportType === "India Other"
  ) {
    columns.push({
      title: <div>{t("Location Coordinate")}</div>,
      dataIndex: "location",
      key: "loginlatitude",
      className: "normal-column",
      align: "start",
      render: (_, record) => {
        const findLocation = locationList?.find(
          (item) => item?.location_id === String(record?.loginlocationid)
        );
        console.log("findLocation", findLocation);
        const hasother = findLocation?.login_from_anywhere === 1 ? true : false;
        console.log("hasother", hasother);
        return (
          <LocationCell
            lat={record.loginlatitude}
            lng={record.loginlongitude}
            hasother={hasother}
            locationName={record.loginlocationname}
          />
        );
      },
    });
  }

  return (
    <>
      <StyledModal
        title={title}
        visible={displayModal}
        onCancel={toggleModal}
        footer={null}
        destroyOnClose
      >
        <StyledTable
          dataSource={list}
          columns={columns}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="name"
          pagination={false}
        />
      </StyledModal>
    </>
  );
}

export default LocationBasedAttendanceList;
